import { useState } from "react";
import Navbar from "../../components/portal/Navbar";
import Footer from "../../components/portal/Footer";
import WhatsAppBtn from "../../components/portal/WhatsAppBtn";
import { portalAPI } from "../../api";
import { useSettings } from "../../context/SettingsContext";
import { telefonoValido, emailValido } from "../../constants/telefono";
import toast from "react-hot-toast";
import "./Contacto.css";

export default function Contacto() {
  const [form, setForm] = useState({ name: "", email: "", phone: "", subject: "", message: "" });
  const [enviando, setEnviando] = useState(false);
  const [enviado, setEnviado] = useState(false);
  const { settings } = useSettings();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name.trim()) { toast.error("Escribe tu nombre"); return; }
    if (!telefonoValido(form.phone)) { toast.error("Escribe un teléfono de 10 dígitos"); return; }
    if (form.email.trim() && !emailValido(form.email)) { toast.error("El correo no es válido"); return; }
    if (!form.message.trim()) { toast.error("Escribe tu mensaje"); return; }
    setEnviando(true);
    try {
      await portalAPI.contacto({ ...form, property_id: null });
      setEnviado(true);
      setForm({ name: "", email: "", phone: "", subject: "", message: "" });
      toast.success("¡Mensaje enviado correctamente!");
    } catch (err) {
      toast.error(err.response?.data?.message || "Error al enviar. Intenta de nuevo.");
    } finally {
      setEnviando(false);
    }
  };

  return (
      <div>
        <Navbar />
        <div className="contacto-page">
          {/* Hero pequeño */}
          <div className="contacto-hero">
            <div className="container">
              <p className="hero-eyebrow" style={{ color: "var(--color-accent)" }}>Estamos para ayudarte</p>
              <h1 className="heading-serif" style={{ color: "#fff", fontSize: "2.5rem" }}>Contáctanos</h1>
            </div>
          </div>

          <div className="container contacto-body">
            {/* Formulario */}
            <div className="contacto-form-col card">
              {enviado ? (
                  <div className="contacto-success">
                    <div style={{ fontSize: "3rem" }}>✅</div>
                    <h3>¡Mensaje recibido!</h3>
                    <p>Gracias por contactarnos. Te responderemos a la brevedad posible.</p>
                    <button className="btn btn-primary" onClick={() => setEnviado(false)}>
                      Enviar otro mensaje
                    </button>
                  </div>
              ) : (
                  <>
                    <h2 className="heading-serif" style={{ fontSize: "1.5rem", marginBottom: "1.5rem" }}>
                      Envíanos un mensaje
                    </h2>
                    <form onSubmit={handleSubmit} className="contacto-form-inner">
                      <div className="form-row">
                        <div className="form-group">
                          <label className="form-label" htmlFor="con-nombre">Nombre completo *</label>
                          <input
                              id="con-nombre"
                              className="form-input"
                              autoComplete="name"
                              value={form.name}
                              onChange={(e) => setForm({ ...form, name: e.target.value })}
                              placeholder="Tu nombre"
                          />
                        </div>
                        <div className="form-group">
                          <label className="form-label" htmlFor="con-tel">Teléfono / WhatsApp *</label>
                          <input
                              id="con-tel"
                              type="tel"
                              inputMode="tel"
                              autoComplete="tel"
                              className="form-input"
                              value={form.phone}
                              onChange={(e) => setForm({ ...form, phone: e.target.value })}
                              placeholder="10 dígitos"
                          />
                        </div>
                      </div>
                      <div className="form-row">
                        <div className="form-group">
                          <label className="form-label" htmlFor="con-email">
                            Email <span style={{ fontWeight: 400, fontSize: ".8rem", color: "var(--color-text-muted)" }}>(opcional)</span>
                          </label>
                          <input
                              id="con-email"
                              type="email"
                              autoComplete="email"
                              className="form-input"
                              value={form.email}
                              onChange={(e) => setForm({ ...form, email: e.target.value })}
                              placeholder="tu@email.com"
                          />
                        </div>
                        <div className="form-group">
                          <label className="form-label">Asunto</label>
                          <select
                              className="form-select"
                              value={form.subject}
                              onChange={(e) => setForm({ ...form, subject: e.target.value })}
                          >
                            <option value="">Selecciona un asunto</option>
                            <option value="Quiero comprar">Quiero comprar una propiedad</option>
                            <option value="Quiero rentar">Quiero rentar una propiedad</option>
                            <option value="Quiero vender">Quiero vender mi propiedad</option>
                            <option value="Información general">Información general</option>
                            <option value="Otro">Otro</option>
                          </select>
                        </div>
                      </div>
                      <div className="form-group">
                        <label className="form-label">Mensaje *</label>
                        <textarea
                            className="form-textarea"
                            rows={5}
                            value={form.message}
                            onChange={(e) => setForm({ ...form, message: e.target.value })}
                            placeholder="Cuéntanos en qué podemos ayudarte..."
                        />
                      </div>
                      <button
                          type="submit"
                          className="btn btn-primary btn-lg"
                          style={{ width: "100%" }}
                          disabled={enviando}
                      >
                        {enviando ? "Enviando..." : "📩 Enviar mensaje"}
                      </button>
                    </form>
                  </>
              )}
            </div>

            {/* Datos de contacto */}
            <aside className="contacto-info">
              <h2 className="heading-serif" style={{ fontSize: "1.5rem", marginBottom: "1.5rem" }}>
                Información de contacto
              </h2>
              <div className="info-cards">
                {(settings.contact_address || settings.contact_address_2) && (
                    <div className="info-card card">
                      <span className="info-icon">📍</span>
                      <div>
                        <h4>Dirección</h4>
                        <p>
                          {settings.contact_address}
                          {settings.contact_address_2 && <><br />{settings.contact_address_2}</>}
                        </p>
                      </div>
                    </div>
                )}
                {settings.contact_phone && (
                    <div className="info-card card">
                      <span className="info-icon">📞</span>
                      <div>
                        <h4>Teléfono</h4>
                        <a href={`tel:${settings.contact_phone.replace(/\D/g, "")}`}>
                          {settings.contact_phone}
                        </a>
                      </div>
                    </div>
                )}
                {settings.contact_email && (
                    <div className="info-card card">
                      <span className="info-icon">✉️</span>
                      <div>
                        <h4>Email</h4>
                        <a href={`mailto:${settings.contact_email}`}>{settings.contact_email}</a>
                      </div>
                    </div>
                )}
                {(settings.contact_hours_weekdays || settings.contact_hours_saturday) && (
                    <div className="info-card card">
                      <span className="info-icon">🕐</span>
                      <div>
                        <h4>Horario</h4>
                        <p>
                          {settings.contact_hours_weekdays && <>{settings.contact_hours_weekdays}<br /></>}
                          {settings.contact_hours_saturday && <>{settings.contact_hours_saturday}<br /></>}
                          {settings.contact_hours_sunday && <>{settings.contact_hours_sunday}</>}
                        </p>
                      </div>
                    </div>
                )}
              </div>

              {settings.whatsapp_number && (
                  <div className="whatsapp-cta card">
                    <p>¿Prefieres escribirnos directamente?</p>
                    <a
                        href={`https://wa.me/${settings.whatsapp_number}?text=${encodeURIComponent(settings.whatsapp_message || `Hola, me interesa obtener información sobre ${settings.site_name}.`)}`}
                        target="_blank"
                        rel="noreferrer"
                        className="btn btn-lg"
                        style={{ background: "#25D366", color: "#fff", width: "100%", justifyContent: "center" }}
                    >
                      <svg viewBox="0 0 24 24" fill="currentColor" width="22" height="22" style={{ flexShrink: 0 }}>
                        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                      </svg>
                      Chatear por WhatsApp
                    </a>
                  </div>
              )}
            </aside>
          </div>
        </div>
        <Footer />
        <WhatsAppBtn />
      </div>
  );
}